import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ConfirmationDialog from '@/components/ui/ConfirmationDialog/ConfirmationDialog';
import { SystemMessageDtoIn } from '@/models/in/SystemMessageDtoIn';
import { useDeleteAuthApi } from '@/hooks/UseApiCalls';
import { SYSTEM_MESSAGES_MANAGEMENT_URL } from './systemMessages';

interface DeleteSystemMessageDialogProps {
  open: boolean;
  onClose: () => void;
  message: SystemMessageDtoIn;
  onSuccess: () => void;
}

const DeleteSystemMessageDialog = ({ open, onClose, message, onSuccess }: DeleteSystemMessageDialogProps) => {
  const { t } = useTranslation();
  const [error, setError] = useState<string | null>(null);

  const { mutate: deleteMessage, isPending: isDeleting } = useDeleteAuthApi<void>(`${SYSTEM_MESSAGES_MANAGEMENT_URL}/${message.id}`);

  const handleDelete = () => {
    setError(null);
    deleteMessage(undefined, {
      onSuccess: () => {
        onSuccess();
        onClose();
      },
      onError: () => setError(t('systemMessages.dialog.errorDeleting')),
    });
  };

  const handleClose = () => {
    setError(null);
    onClose();
  };

  const confirmation = t('systemMessages.confirmDelete', { title: message.title });

  return (
    <ConfirmationDialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) handleClose();
      }}
      title={t('systemMessages.delete')}
      message={error ? `${confirmation}\n\n${error}` : confirmation}
      confirmText={isDeleting ? 'saving' : 'systemMessages.delete'}
      cancelText="cancel"
      onConfirm={handleDelete}
      onCancel={handleClose}
      isLoading={isDeleting}
      variant="danger"
    />
  );
};

export default DeleteSystemMessageDialog;
